<div class="upcoming-maintenances" *transloco="let t; prefix: 'maintenanceOverview'">
  <div class="filter-container pb-3">
    <app-search
      [placeholder]="t('table.searchAsset')"
      [disabled]="isLoading"
      (searchTermUpdated)="onSearchTermUpdate($event)"
      [searchTerm]="searchTerm"
      [customWidth]="'300px'">
    </app-search>
  </div>

  <div class="table-container">
    <div class="table-inner">
      @if (isLoading) {
        <div class="loading-overlay">
          <span class="spinner-border"></span>
        </div>
      } @else if (hasError) {
        <div class="state-overlay">
          <app-error-state></app-error-state>
        </div>
      } @else if (!upcomingMaintenances.length) {
        <div class="state-overlay">
          <app-empty-state></app-empty-state>
        </div>
      }

      <table
        class="maintenance-table"
        [class.is-loading]="isLoading"
        [class.is-full-page]="!isLoading && upcomingMaintenances.length >= pageSize">
        <thead>
          <tr>
            <th class="asset">{{ t('table.asset') }}</th>
            <th class="maint-model">{{ t('table.maintModel') }}</th>
            <th class="source">{{ t('table.source') }}</th>
            <th class="distance-over">{{ t('table.distanceOver') }}</th>
            <th class="service-type">{{ t('table.serviceType') }}</th>
            <th class="assigned-to">{{ t('table.assignedTo') }}</th>
            <th class="estimated-cost">{{ t('table.estimatedCost') }}</th>
            <th class="due-date">{{ t('table.dueDate') }}</th>
            <th class="status">{{ t('table.status') }}</th>
            <th class="actions">{{ t('table.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          @if (isLoading) {
            <tr class="loading-row">
              <td colspan="10"></td>
            </tr>
          } @else if (upcomingMaintenances.length) {
            @for (row of upcomingMaintenances; track row.id) {
              <tr>
                <td class="asset">
                  <span class="asset-name" [title]="row.assetName">{{ row.assetName }}</span>
                </td>
                <td class="maint-model">{{ getMaintenanceModel(row.maintenanceModel) }}</td>
                <td class="source">
                  <div class="two-line-cell">
                    <span class="source-text" [title]="getMaintenanceSource(row.maintenanceSource)">{{ getMaintenanceSource(row.maintenanceSource) }}</span>
                    <span class="sub-text">{{ formatDate(row.createdAt) }}</span>
                  </div>
                </td>
                <td class="distance-over">{{ formatDistanceOver(row.distanceOver) }}</td>
                <td class="service-type">
                  <div class="two-line-cell">
                    <span [title]="row.localizedMaintenanceReason || row.maintenanceReason">{{ row.localizedMaintenanceReason || row.maintenanceReason }}</span>
                    <span class="sub-text" [title]="formatMaintenanceType(row.isAutoTrigger, row.maintenanceType)">{{ formatMaintenanceType(row.isAutoTrigger, row.maintenanceType) }}</span>
                  </div>
                </td>
                <td class="assigned-to">{{ row.assignedTo || '-' }}</td>
                <td class="estimated-cost">{{ formatCurrency(row.cost) }}</td>
                <td class="due-date">{{ formatDate(row.dueDate) }}</td>
                <td class="status">
                  <span class="status-badge" [ngClass]="getStatusBadgeClass(row.maintenanceStatus)">
                    @if (row.maintenanceStatus === maintenanceStatus.Approved) {
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203ZM6.66603 10.9407L4.1907 8.4707L5.13203 7.5267L6.6647 9.0567L10.194 5.52736L11.1367 6.47003L6.66603 10.9407Z"
                          fill="#50AD41" />
                      </svg>
                    }
                    @if (row.maintenanceStatus === maintenanceStatus.Overdue) {
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.66667 0C2.99067 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3427 0 6.66667 0ZM5.334 9.60867L2.85867 7.13867L3.8 6.19467L5.33267 7.72467L8.862 4.19533L9.80467 5.138L5.334 9.60867Z"
                          fill="#FF7F00" />
                      </svg>
                    }
                    @if (row.maintenanceStatus === maintenanceStatus.Complete) {
                      <svg class="status-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203ZM6.66603 10.9407L4.1907 8.4707L5.13203 7.5267L6.6647 9.0567L10.194 5.52736L11.1367 6.47003L6.66603 10.9407Z"
                          fill="#3873C9" />
                      </svg>
                    }
                    {{ getStatusLabel(row.maintenanceStatus) }}
                  </span>
                </td>
                <td class="actions">
                  <div ngbDropdown container="body" placement="bottom-end">
                    <button class="btn btn-action" ngbDropdownToggle>
                      <i class="ph ph-dots-three-vertical"></i>
                    </button>
                    <div ngbDropdownMenu class="action-dropdown-menu">
                      <button ngbDropdownItem (click)="onEditClick(row.id)">{{ t('table.edit') }}</button>
                      <button ngbDropdownItem (click)="onRescheduleClick(row)">{{ t('table.reschedule') }}</button>
                      <button ngbDropdownItem (click)="onDeleteClick(row.id)">{{ t('table.delete') }}</button>
                    </div>
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="table-footer">
      <p class="pagination-text">{{ 'common.showingOutOf' | transloco: { current: showingCount, total: totalCount } }}</p>

      <app-pagination [totalPages]="totalPages" [currentPage]="currentPage" (pageChange)="onPageChange($event)"></app-pagination>

      <button class="export-btn" [class.invisible]="true" (click)="onExportClick()" [disabled]="isLoading || isExporting">
        <span>{{ isExporting ? t('table.exporting') : t('table.export') }}</span>
        @if (!isExporting) {
          <img src="./assets/images-fuel/downloadIcon.svg" [attr.alt]="'common.export' | transloco" />
        }
      </button>
    </div>
  </div>
</div>